import React, { useEffect, useState } from 'react';
import { Container, ModalFullScreen } from './styles';
import { PauseCircle, PlayCircle, StopCircle, Timer } from 'phosphor-react';
import { FiMaximize, FiX } from 'react-icons/fi';
import TooltipAdapter from '../TooltipAdapter';


const CardTimer: React.FC = () => {

  const [modalOpen, setModalOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const [time, setTime] = useState('00:00:00');
  const [running, setRunning] = useState(false);

  const handleStop = () => {
    setTime('00:00:00');
    setRunning(false);
  }

  useEffect(() => {
    let interval: any;
    if (running) {
      interval = setInterval(() => {
        const seconds = Number(time.split(':')[2]);
        const minutes = Number(time.split(':')[1]);
        const hours = Number(time.split(':')[0]);

        if (seconds < 59) {
          setTime(
            `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds + 1).padStart(2, '0')}`
          );
        } else if (minutes < 59) {
          setTime(
            `${String(hours).padStart(2, '0')}:${String(minutes + 1).padStart(2, '0')}:00`
          );
        } else {
          setTime(
            `${String(hours + 1).padStart(2, '0')}:00:00`
          );
        }
      }, 1000);
    } else {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [running, time]);

  const toggleExpand = () => {
    setModalOpen(!modalOpen);
    setExpanded(!expanded);
  };

  return (
    <>
      <Container className={`${running ? 'running' : ''} ${expanded ? 'expanded' : ''}`}>
        <header>
          <aside>
            <h1>Cronômetro</h1>
            <Timer weight="duotone"
              size={170}
              style={{
                position: 'absolute',
                top: '20px',
                left: '-40px',
                zIndex: -1,
              }}
              color='#ffffff20'
            />
          </aside>
          <main>
            {expanded ? (
              <TooltipAdapter
                alt="Minimizar"
                place="top"
                cursor="help"
              >
                <button onClick={toggleExpand}>
                  <FiX />
                </button>
              </TooltipAdapter>
            ) : (
              <TooltipAdapter
                alt="Expandir"
                place="top"
                cursor="help"
              >
                <button onClick={toggleExpand}>
                  <FiMaximize />
                </button>
              </TooltipAdapter>
            )}
          </main>
        </header>
        <footer>
          <aside>
            <h1>{time}</h1>
          </aside>
          <main>
            {!running ? (
              <button onClick={() => setRunning(true)}><PlayCircle size={32} weight="fill" color='#ffffff' /></button>
            ) : (
              <button onClick={() => setRunning(false)}><PauseCircle size={32} weight="fill" color='#ffffff' /></button>
            )}
            <button onClick={handleStop}><StopCircle size={32} weight="fill" color='#ffffff' /></button>
          </main>
        </footer>
      </Container>

      {modalOpen && (
        <>
          <ModalFullScreen className={expanded ? 'expanded' : ''} onClick={toggleExpand} />
        </>
      )}
    </>
  );
};

export default CardTimer;
